import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { ICredentials } from '@/utils/types'
import Vue from 'vue'
import { getCookie, setCookie, deleteCookie } from '@/utils/cookie'
import { login, me } from '@/api/authService'
import { PartnerModule } from './partners'
import { ReprintGroupModule } from './reprintGroups'
import { CannedNoteModule } from './cannedNotes'
import { CatalogModule } from './catalog'
import { CartGroupModule } from './cartGroups'
import { CannedEmailModule } from './cannedEmails'
import { ShippingOptionsModule } from './shippingOptions'
//import { ArtModule } from './art' 

@Module({ dynamic: true, store, name: 'auth' })
class Auth extends VuexModule {
    public user: any = JSON.parse(localStorage.getItem('auth-user') ?? 'null')

    @Mutation
    private SET_STATE(user: any) {
        if (user) {
            localStorage.setItem('auth-user', JSON.stringify(user))
            setCookie('ol_auth_token', user.jwtToken, 7)
        } else {
            localStorage.removeItem('auth-user')
            deleteCookie('ol_auth_token')
        }
        this.user = user
    }

    @Action
    public async login(credentials: ICredentials) {
        await login(credentials)
            .then(response => {
                this.SET_STATE(response.data)
                this.restoreContext()
            })
            .catch(() => {
                this.logout()
            })
    }

    @Action
    public async logout() {
        this.SET_STATE(null)
        Vue.prototype.$signalHub.stopSignalR()
    }

    @Action
    public async validateSession() {
        const token = getCookie('ol_auth_token')
        if (!token) return

        // Temporarily set user with token so the interceptor can use it for the me() call
        this.SET_STATE({ jwtToken: token })

        try {
            const response = await me()
            this.SET_STATE(response.data)
            await this.restoreContext()
        } catch (error) {
            console.error('Session validation failed in V4:', error)
            this.SET_STATE(null)
        }
    }

    @Action
    public async restoreContext() {
        if (this.user !== null && this.user.jwtToken) {
            await PartnerModule.getPartners()
            await PartnerModule.getStaplesStores()
            await ReprintGroupModule.getReprintGroups()
            await CannedNoteModule.getCannedNotes()
            await CannedEmailModule.getCannedEmails()
            await CartGroupModule.getCartGroups()
            await CatalogModule.getCatalog()
            await CatalogModule.getTags()
            await CatalogModule.getArtists()
            await ShippingOptionsModule.getShippingOptions()
            Vue.prototype.$signalHub.startSignalR(`${this.user.jwtToken}`)
        } else {
            console.warn('Cannot restore not logged in')
        }
    }
}

export const AuthModule = getModule(Auth)
